export default "__VITE_ASSET__U02SFniP__"